import { yupResolver } from "@hookform/resolvers/yup";
import {
  Box,
  Button,
  Card,
  Divider,
  FormControl,
  FormHelperText,
  Grid,
  InputLabel,
  OutlinedInput,
  Stack,
  Typography,
} from "@mui/material";
import Chip from "@mui/material/Chip";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import { useTheme } from "@mui/material/styles";
import React, { useEffect, useRef, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { toast } from "react-hot-toast";
import ImageUploading from "react-images-uploading";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import RichTextEditor from "react-rte";
import * as yup from "yup";
import Appbar from "../../components/Appbar";
import Body from "../../components/Body";
import Drawer from "../../components/Drawer";
import { categoryApi } from "../../store/categoryDetails/categoryList";
import { classGlobalApi } from "../../store/class/classListGlobal";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { subjectGlobalApi } from "../../store/subject/subjectListGlobal";
import { uploadHandoutsApi } from "../../store/upload/uploadHandouts";
import { uploadImageApi } from "../../store/upload/uploadImage";
import BackdropUI from "../../ui/Backdrop";
import dayjs from "dayjs";
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import { topicsGlobalApi } from "../../store/topics/topicsListGlobal";
import {
  getParticularcompetitionAPI,
  resetgetparticularcompetition,
} from "../../store/competition/getcompetition";
import { EditcompetitionApi } from "../../store/competition/editcompetition";
import { addcompetitionApi } from "../../store/competition/addcompetition";
dayjs.extend(utc);
dayjs.extend(timezone);
const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

function getStyles(name, personName, theme) {
  return {
    fontWeight:
      personName.indexOf(name) === -1
        ? theme.typography.fontWeightRegular
        : theme.typography.fontWeightMedium,
  };
}

const schema = yup
  .object({
    title: yup.string().required("Please provide content name").trim(),
    source: yup.string().required("Please provide source name").trim(),
    description: yup.string().required("Please Provide description").trim(),
    terms_and_conditions: yup.string().required("Please Provide Terms and Condition").trim(),
    points: yup
      .number()
      .required("Please provide number of stars ")
      .min(1, "Minimum stars should be 1")
      .max(1000, "Max stars can be 1000")
      .typeError("Please provide a number"),
    topics: yup.array()
      .of(yup.string())
      .min(1, 'At least one topics is required')
      .required(),
    // classes: yup.array()
    //   .of(yup.string())
    //   .min(1, 'At least one classes is required')
    //   .required(),
    // subjects: yup.array()
    //   .of(yup.string())
    //   .min(1, 'At least one subjects is required')
    //   .required(),
    is_approved: yup.string().required("Please select option "),
    language: yup.string().required("Please select language "),
    // link: yup.string().required("Please submit your link "),
  })
  .required();

export default function EditCompetition() {
  const theme = useTheme();
  const [fileUploadLoader, setFileUploadLoader] = useState(false);
  const shortVideoEdit = useSelector((state) => state?.editcompetetion);
  const shortVideoAdd = useSelector((state) => state?.addcompetetion);
  const shortVideoDetail = useSelector(
    (state) => state?.getparticularDetailscompetetionAdmin
  );
  const uploadImage = useSelector((state) => state?.uploadImage);
  const { result, loiding } = shortVideoDetail;
  const {
    result: {
      title,
      source,
      video_url,
      mobile_number,
      duration: timeDuration,
      points,
      meta_tags,
      description,
      terms_and_conditions,
      submit_date,
      start_date,
      topics,
    },
  } = shortVideoDetail;

  const dispatch = useDispatch();
  const refInput = useRef(null);
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    watch,
    control,
    setValue,
  } = useForm({ resolver: yupResolver(schema), defaultValues: {} });
  const uploadHandouts = useSelector((state) => state?.uploadHandouts);
  const { result: topicsList, loading: topicsLoading } = useSelector(
    (state) => state?.topicsGlobal
  );
  const { result: classList, loading: classLoading } = useSelector(
    (state) => state?.classGlobal
  );
  const { result: subjectList, loading: subjectLoading } = useSelector(
    (state) => state?.subjectGlobal
  );
  const [cat, setCat] = useState();
  const [meta, setMeta] = useState("");
  const [metaTag, setMetaTag] = useState([]);
  const [images, setImages] = React.useState([]);
  const [duration, setDuration] = useState("0:00");
  const [imageLink, setImageLink] = useState();
  const ref = useRef(null);
  const [dateTime, setDateTime] = useState();
  const [startdateTime, setStartdateTime] = useState();
  const params = useParams();
  const navigate = useNavigate();
  const [is_approved, setisApproved] = useState();
  const [classValue, setClassValue] = useState();
  const [language, setLanguage] = useState();
  const [chooseSubjects, setChooseSubjects] = useState();
  const categories = useSelector((state) => state?.categories);
  const [valueDescription, setValueDescription] = useState("");
  const [handOuts, setHandouts] = React.useState([]);
  const [editorValue, setEditorValue] = React.useState(
    RichTextEditor.createValueFromString("", "markdown")
  );
  useEffect(() => {
    return () => {
      dispatch(resetgetparticularcompetition());
    };
  }, []);
  useEffect(() => {
    // dispatch(categoryApi());
    dispatch(classGlobalApi());
    dispatch(topicsGlobalApi());
    dispatch(subjectGlobalApi());
    if (params.id) {
      dispatch(getParticularcompetitionAPI(params.id));
    }
  }, []);
  useEffect(() => {
    setDuration(timeDuration);
    // setCat(shortVideoDetail.result?.topics);
    // setClassValue(shortVideoDetail.result?.classes);
    // setChooseSubjects(shortVideoDetail.result?.subjects);
    setLanguage(shortVideoDetail.result?.language);
    setisApproved(shortVideoDetail.result?.source_type);
    setImageLink(shortVideoDetail.result?.thumbnail);
    if (meta_tags) {
      setMetaTag(meta_tags.split(","));
    }
    setDateTime(shortVideoDetail.result.submit_date);
    setStartdateTime(shortVideoDetail.result.start_date)
    //console.log(duration);
  }, [shortVideoDetail]);
  const onUploadHandout = async (file) => {
    setFileUploadLoader(true);
    let formData = new FormData();
    formData.append("file", file);
    dispatch(uploadHandoutsApi(formData)).then((res) => {
      if (res.payload.result.length > 0 && !res.payload.result.error) {

        let obj = {
          fileName: file.name,
          fileUrl: res.payload.result,
        };
        setHandouts([...handOuts, obj]);
        setFileUploadLoader(false)

        refInput.current.value = null;
      }
    })
  };
  const onUploadImage = async (imageList, addUpdateIndex) => {
    setFileUploadLoader(true);
    if (imageList.length > 0) {
      let formData = new FormData();

      formData.append("file", imageList[0]?.file);
      // await dispatch(uploadImageApi(formData));
      const res = await dispatch(uploadImageApi(formData));
      try {
        if (res?.payload?.status === 400) {
          setImages([]);
          return
        }
      } finally {
        setFileUploadLoader(false)
      }
    }
    setImages(imageList);
    setFileUploadLoader(false);
  };

  const handleUpdateForm = async (data) => {
    var newObj;

    if (imageLink) {
      newObj = { ...data, thumbnail: imageLink };
    } else if (
      images.length > 0 &&
      !uploadImage?.loading &&
      uploadImage.result
    ) {
      newObj = { ...data, thumbnail: uploadImage.result };
    } else {
      toast.error("Please Upload An Image", {
        id: "toast",
        duration: 1000,
        position: "top-center",
      });
      return;
    }
    // if (handOuts.length === 0) {

    //   toast.error("Please Upload An File", {
    //     id: "toast",
    //     duration: 1000,
    //     position: "top-center",
    //   });
    //   return;
    // }
    if (metaTag.length < 5) {
      toast.error("Please provide 5 meta tags", {
        id: "toast",
        duration: 4000,
        position: "top-center",
      });
      return;
    }
    if (handOuts.length > 0) {
      newObj = {
        ...newObj,
        meta_tags: metaTag.join(","),
        source_type: is_approved,
        // hhw_class: data["classes"],
        // subjects: data["subjects"],
        file: handOuts[0].fileUrl,
        file_name: handOuts[0].fileName,
      };
    }

    if (!dateTime) {
      toast.error("Please provide submit date time", {
        id: "toast",
        duration: 4000,
        position: "top-center",
      });
      return;
    }
    // if (!startdateTime) {
    //   toast.error("Please provide start date time", {
    //     id: "toast",
    //     duration: 4000,
    //     position: "top-center",
    //   });
    //   return;
    // }
    newObj = {
      ...newObj, submit_date: dateTime, meta_tags: metaTag.join(","),
      source_type: is_approved,
    };
    const { classes, video_url, ...rest } = newObj;

    if (params.id) {
      let obj = { ...rest, id: params.id };
      await dispatch(EditcompetitionApi(obj));
      if (!shortVideoEdit?.loading) {
        navigate("/competition");
      }
    } else {
      await dispatch(addcompetitionApi(newObj));
      if (!shortVideoAdd?.loading) {
        navigate("/competition");
      }
    }
  };
  const handleHandoutDelete = (element) => {
    var local = handOuts;
    setHandouts(local.filter((item) => item !== element));
  };
  const handleChipDelete = (element) => {
    var local = metaTag;
    setMetaTag(local.filter((item) => item !== element));
  };
  const handleChipAdd = (value) => {
    if (!metaTag.includes(ref?.current?.value.trim())) {
      setMetaTag([...metaTag, meta]);
      setMeta(null);
      ref.current.value = null;
    } else {
      toast.error("This Meta Tag Already Exists", {
        id: "toast",
        duration: 4000,
        position: "top-center",
      });
    }
    //console.log(ref);
  };

  useEffect(() => {
    let defalutValues = {};
    defalutValues["title"] = result?.title;
    defalutValues["description"] = result?.description;
    defalutValues["terms_and_conditions"] = result?.terms_and_conditions;

    defalutValues["source"] = result?.source;
    // defalutValues["video_url"] = result?.video_url;
    defalutValues["thumbnail"] = result?.thumbnail;
    defalutValues["points"] = result?.points;
    defalutValues["link"] = result?.link;
    defalutValues["language"] = result?.language;
    defalutValues["submit_date"] = result?.submit_date;
    // defalutValues["start_date"] = result?.start_date;
    defalutValues["is_approved"] = result?.source_type;
    defalutValues["subjects"] = result?.subjects?.map((o) => o?.id);
    defalutValues["classes"] = result?.classes?.map((o) => o?.id);
    defalutValues["topics"] = result?.topics?.map((o) => o?.id);
    if (result?.description) {
      setEditorValue(
        RichTextEditor.createValueFromString(result?.description, "html")
      );
    }
    if (result?.file && result?.file_name) {
      let document = { file: result?.file, fileName: result?.file_name };
      setHandouts([document]);
    }

    reset(defalutValues);
  }, [result]);
  const getSecondsFromHHMMSS = (value) => {
    const [str1, str2, str3] = value.split(":");

    const val1 = Number(str1);
    const val2 = Number(str2);
    const val3 = Number(str3);

    if (!isNaN(val1) && isNaN(val2) && isNaN(val3)) {
      return val1;
    }

    if (!isNaN(val1) && !isNaN(val2) && isNaN(val3)) {
      return val1 * 60 + val2;
    }

    if (!isNaN(val1) && !isNaN(val2) && !isNaN(val3)) {
      return val1 * 60 * 60 + val2 * 60 + val3;
    }

    return 0;
  };
  const toHHMMSS = (secs) => {
    const secNum = parseInt(secs.toString(), 10);
    const hours = Math.floor(secNum / 3600);
    const minutes = Math.floor(secNum / 60) % 60;
    const seconds = secNum % 60;

    return [hours, minutes, seconds]
      .map((val) => (val < 10 ? `0${val}` : val))
      .filter((val, index) => val !== "00" || index > 0)
      .join(":")
      .replace(/^0/, "");
  };
  const handleDurtion = (e) => {
    //console.log(e.target.value)
    const value1 = e.target.value;
    const seconds = Math.max(0, getSecondsFromHHMMSS(value1));

    const time = toHHMMSS(seconds);

    setDuration(time);
  };
  const handleChange = (value) => {
    setEditorValue(value);
    setValueDescription(value.toString("html"));
  };
  return (
    <>
      <Appbar />
      <Drawer />
      <Body>
        <form onSubmit={handleSubmit(handleUpdateForm)}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <Card>
                <Typography>Details</Typography>
                <Stack spacing={2} my={2}>
                  <Divider />
                  <>
                    <Stack direction="row" spacing={2}>
                      <FormControl variant="outlined" fullWidth>
                        <InputLabel shrink>Title*</InputLabel>
                        <OutlinedInput
                          {...register("title")}
                          label="title"
                          notched
                          id="outlined-adornment-email"
                          error={errors?.title?.message}
                          defaultValue={result.title}
                        />
                        <FormHelperText error>
                          {errors?.title?.message}
                        </FormHelperText>
                      </FormControl>
                      <FormControl variant="outlined" fullWidth>
                        <InputLabel shrink>Source*</InputLabel>
                        <OutlinedInput
                          {...register("source")}
                          label="source"
                          notched
                          id="outlined-adornment-email"
                          error={errors?.source?.message}
                          defaultValue={result.source}
                        />
                        <FormHelperText error>
                          {errors?.source?.message}
                        </FormHelperText>
                      </FormControl>
                      <FormControl variant="outlined" fullWidth>
                        <InputLabel htmlFor="outlined-adornment-email" shrink>
                          Topics*
                        </InputLabel>
                        <Controller
                          name="topics"
                          control={control}
                          defaultValue={[]}
                          render={({ field }) => (
                            <Select
                              {...field}
                              multiple
                              value={watch('topics', [])}
                              onChange={(e) => {
                                const {
                                  target: { value },
                                } = e;
                                setValue('topics', typeof value === 'string' ? value.split(',') : value);
                                field.onChange(e);
                              }}
                              input={<OutlinedInput id="select-multiple-chip" label="Chip" />}
                              renderValue={(selected) => (
                                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                                  {selected.map((value) => (
                                    <Chip key={value} label={topicsList.find(obj => obj?.id === value)?.title || ""} />
                                  ))}
                                </Box>
                              )}
                              MenuProps={MenuProps}
                            >
                              {topicsList.map((obj) => (
                                <MenuItem
                                  key={obj.title}
                                  value={obj.id}
                                  style={getStyles(obj.title, watch('topics', []), theme)}
                                >
                                  {obj.title}
                                </MenuItem>
                              ))}
                            </Select>
                          )}
                        />
                        <FormHelperText error>
                          {errors?.topics?.message}
                        </FormHelperText>
                      </FormControl>
                    </Stack>
                    <Stack direction="row" spacing={2}>
                      <FormControl variant="outlined" fullWidth>
                        <InputLabel shrink>Description*</InputLabel>
                        <OutlinedInput
                          {...register("description")}
                          label="Description"
                          notched
                          multiline
                          error={errors?.description?.message}
                          defaultValue={description}
                        />
                        <FormHelperText error>
                          {errors?.description?.message}
                        </FormHelperText>
                      </FormControl>
                      {/* <FormControl variant="outlined" fullWidth>
                      
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DateTimePicker
                          {...register("start_date")}
                          label="Start Date & Time*"
                          name="start_date"
                          // disabled={ submit_date}
                          error={errors?.date?.message}
                          value={startdateTime ? dayjs(startdateTime).tz('Asia/Kolkata') : null}
                          onChange={(newValue) => {
                            setStartdateTime(dayjs(newValue).toJSON());
                            console.log("sajhdaskjdasd", dayjs(newValue).utc().toJSON())
                          }}
                          // shouldDisableDate={shouldDisableDate}
                        />
                      </LocalizationProvider>
                      <FormHelperText error>
                        {errors?.date?.message}
                      </FormHelperText>
                    </FormControl> */}
                      <FormControl variant="outlined" fullWidth>

                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DateTimePicker
                            {...register("submit_date")}
                            label="Submit Date & Time*"
                            name="date"
                            // disabled={ submit_date}
                            error={errors?.date?.message}
                            value={dateTime ? dayjs(dateTime).tz('Asia/Kolkata') : null}
                            onChange={(newValue) => {
                              setDateTime(dayjs(newValue).toJSON());
                              console.log("sajhdaskjdasd", dayjs(newValue).utc().toJSON())
                            }}
                          // shouldDisableDate={shouldDisableDate}
                          />
                        </LocalizationProvider>
                        <FormHelperText error>
                          {errors?.date?.message}
                        </FormHelperText>
                      </FormControl>
                    </Stack>
                    <Stack direction="row" spacing={2}>

                      <FormControl variant="outlined" fullWidth>
                        <InputLabel shrink>Link</InputLabel>
                        <OutlinedInput
                          {...register("link")}
                          label="Link"
                          notched
                          id="outlined-adornment-email"
                          error={errors?.link?.message}
                          defaultValue={result.link}
                        />
                        <FormHelperText error>
                          {errors?.link?.message}
                        </FormHelperText>
                      </FormControl>
                    </Stack>
                    <Stack direction="row" spacing={2}>
                      <FormControl variant="outlined" fullWidth>
                        <InputLabel shrink>Allocated Stars*</InputLabel>
                        <OutlinedInput
                          {...register("points")}
                          label="Allocated Stars"
                          notched
                          id="outlined-adornment-email"
                          error={errors?.points?.message}
                          defaultValue={result.points}
                        />
                        <FormHelperText error>
                          {errors?.points?.message}
                        </FormHelperText>
                      </FormControl>
                      <FormControl variant="outlined" fullWidth>
                        <InputLabel>Meta Tag</InputLabel>
                        <OutlinedInput
                          label="meta_tag"
                          id="outlined-adornment-email"
                          onChange={(e) => {
                            if (e.target.value.trim().length > 0) {
                              setMeta(e.target.value);
                            } else {
                              setMeta(null);
                              ref.current.value = null;
                            }
                          }}
                          defaultValue={meta}
                          inputRef={ref}
                          endAdornment={
                            <Button
                              variant="contained"
                              className="btn3"
                              disabled={
                                ref?.current?.value.trim().length > 0
                                  ? false
                                  : true
                              }
                              onClick={() => handleChipAdd()}
                            >
                              Add
                            </Button>
                          }
                        />
                        <FormHelperText error></FormHelperText>
                        <Stack
                          direction="row"
                          spacing={1}
                          style={{ display: " inline" }}
                        >
                          {metaTag.map((i, element) => (
                            <>
                              <Chip
                                label={i}
                                variant="outlined"
                                style={{ marginTop: "5px" }}
                                className=""
                                onDelete={() => handleChipDelete(i)}
                              />
                            </>
                          ))}
                        </Stack>
                      </FormControl>
                    </Stack>
                    <Stack direction="row" spacing={2}>
                      <FormControl variant="outlined" fullWidth>
                        <InputLabel htmlFor="outlined-adornment-email" shrink>
                          Subject
                        </InputLabel>
                        <Controller
                          name="subjects"
                          control={control}
                          defaultValue={[]}
                          render={({ field }) => (
                            <Select
                              {...field}
                              multiple
                              value={watch("subjects", [])}
                              onChange={(e) => {
                                const {
                                  target: { value },
                                } = e;
                                setValue(
                                  "subjects",
                                  typeof value === "string"
                                    ? value.split(",")
                                    : value
                                );
                                field.onChange(e);
                              }}
                              input={
                                <OutlinedInput
                                  id="select-multiple-chip"
                                  label="Chip"
                                />
                              }
                              renderValue={(selected) => (
                                <Box
                                  sx={{
                                    display: "flex",
                                    flexWrap: "wrap",
                                    gap: 0.5,
                                  }}
                                >
                                  {selected.map((value) => (
                                    <Chip
                                      key={value}
                                      label={
                                        subjectList.find(
                                          (obj) => obj.id === value
                                        )?.title || ""
                                      }
                                    />
                                  ))}
                                </Box>
                              )}
                              MenuProps={MenuProps}
                            >
                              {subjectList.map((obj) => (
                                <MenuItem
                                  key={obj.title}
                                  value={obj.id}
                                  style={getStyles(
                                    obj.title,
                                    watch("subjects", []),
                                    theme
                                  )}
                                >
                                  {obj.title}
                                </MenuItem>
                              ))}
                            </Select>
                          )}
                        />
                        <FormHelperText error>
                          {errors?.subjects?.message}
                        </FormHelperText>

                      </FormControl>
                      <FormControl variant="outlined" fullWidth>
                        <InputLabel htmlFor="outlined-adornment-email" shrink>
                          Class
                        </InputLabel>
                        <Controller
                          name="classes"
                          control={control}
                          defaultValue={[]}
                          render={({ field }) => (
                            <Select
                              {...field}
                              multiple
                              value={watch("classes", [])}
                              onChange={(e) => {
                                const {
                                  target: { value },
                                } = e;
                                setValue(
                                  "classes",
                                  typeof value === "string"
                                    ? value.split(",")
                                    : value
                                );
                                field.onChange(e);
                              }}
                              input={
                                <OutlinedInput
                                  id="select-multiple-chip"
                                  label="Chip"
                                />
                              }
                              renderValue={(selected) => (
                                <Box
                                  sx={{
                                    display: "flex",
                                    flexWrap: "wrap",
                                    gap: 0.5,
                                  }}
                                >
                                  {selected.map((value) => (
                                    <Chip
                                      key={value}
                                      label={
                                        classList.find(
                                          (obj) => obj.id === value
                                        )?.title || ""
                                      }
                                    />
                                  ))}
                                </Box>
                              )}
                              MenuProps={MenuProps}
                            >
                              {classList.map((obj) => (
                                <MenuItem
                                  key={obj.title}
                                  value={obj.id}
                                  style={getStyles(
                                    obj.title,
                                    watch("classes", []),
                                    theme
                                  )}
                                >
                                  {obj.title}
                                </MenuItem>
                              ))}
                            </Select>
                          )}
                        />

                        <FormHelperText error>
                          {errors?.classes?.message}
                        </FormHelperText>
                      </FormControl>
                    </Stack>
                    <Stack direction="row" spacing={2}>
                      <FormControl variant="outlined" fullWidth>
                        <InputLabel htmlFor="outlined-adornment-email" shrink>
                          Competition*
                        </InputLabel>
                        <Select
                          {...register("is_approved")}
                          label="Approved"
                          notched
                          id="outlined-adornment-category"
                          error={!!errors?.is_approved?.message}
                          value={is_approved != null ? is_approved : null}
                          onChange={(e) => setisApproved(e.target.value)}
                        >
                          <MenuItem value={"internal"}>Internal</MenuItem>
                          <MenuItem value={"external"}>External</MenuItem>
                        </Select>

                        <FormHelperText error>
                          {errors?.is_approved?.message}
                        </FormHelperText>
                      </FormControl>
                      <FormControl variant="outlined" fullWidth>
                        <InputLabel htmlFor="outlined-adornment-email" shrink>
                          Language*
                        </InputLabel>
                        <Select
                          {...register("language")}
                          label="Language"
                          notched
                          id="outlined-adornment-category"
                          error={!!errors?.language?.message}
                          value={language ? language : null}
                          onChange={(e) => setLanguage(e.target.value)}
                        >
                          <MenuItem value={"hindi"}>Hindi</MenuItem>
                          <MenuItem value={"english"}>English</MenuItem>
                          <MenuItem value={"both"}>Both</MenuItem>
                        </Select>

                        <FormHelperText error>
                          {errors?.language?.message}
                        </FormHelperText>
                      </FormControl>
                      {/* <FormControl variant="outlined" fullWidth>
                        <InputLabel shrink>Duration*</InputLabel>
                        <OutlinedInput
                          {...register("duration")}
                          label="Duration"
                          name="duration"
                          id="outlined-adornment-email"
                          notched
                          value={duration}
                          onChange={(e) => handleDurtion(e)}
                          error={errors?.duration?.message}
                        />
                        <FormHelperText error>
                          {errors?.duration?.message}
                        </FormHelperText>

                      </FormControl> */}
                    </Stack>
                    <Stack direction="row" spacing={2}>
                      <FormControl variant="outlined" fullWidth>
                        <InputLabel shrink>Terms and Conditions</InputLabel>
                        <OutlinedInput
                          {...register("terms_and_conditions")}
                          label="Terms and Conditions"
                          notched
                          rows={4}
                          multiline
                          error={errors?.terms_and_conditions?.message}
                          defaultValue={terms_and_conditions}
                        />
                        <FormHelperText error>
                          {errors?.terms_and_conditions?.message}
                        </FormHelperText>
                      </FormControl>

                    </Stack>

                    <InputLabel>Thumbnail Image</InputLabel>
                    {imageLink ? (
                      <div className="image-item">
                        <img src={imageLink} alt="" width="320" height="180" />
                        <div className="image-item__btn-wrapper">
                          <Button
                            onClick={() => setImageLink(null)}
                            variant="contained"
                          >
                            Remove
                          </Button>
                        </div>
                      </div>
                    ) : (
                      <ImageUploading
                        acceptType={["png", "jpeg", "jpg"]}
                        value={images}
                        onChange={onUploadImage}
                        maxNumber={1}
                        dataURLKey="data_url"
                      >
                        {({
                          imageList,
                          onImageUpload,
                          onImageRemoveAll,
                          onImageUpdate,
                          onImageRemove,
                          isDragging,
                          dragProps,
                          errors,
                        }) => (
                          <>
                            <div
                              className="upload__image-wrapper"
                              style={{ marginTop: "2%", marginBottom: "2%" }}
                            >
                              {imageList.length > 0 ? null : (
                                <Button
                                  type="button"
                                  variant="contained"
                                  style={
                                    isDragging ? { color: "red" } : undefined
                                  }
                                  onClick={onImageUpload}
                                  {...dragProps}
                                >
                                  Click or Drop here
                                </Button>
                              )}

                              {errors && (
                                <div>
                                  {errors.maxNumber && (
                                    <span>
                                      Number of selected images exceed maxNumber
                                    </span>
                                  )}
                                  {errors.acceptType && (
                                    <span>
                                      Your selected file type is not allow
                                    </span>
                                  )}
                                  {errors.maxFileSize && (
                                    <span>
                                      Selected file size exceed maxFileSize
                                    </span>
                                  )}
                                  {errors.resolution && (
                                    <span>
                                      Selected file is not match your desired
                                      resolution
                                    </span>
                                  )}
                                </div>
                              )}
                              {imageList.map((image, index) => (
                                <div key={index} className="image-item">
                                  <img
                                    src={image["data_url"]}
                                    alt=""
                                    width="320"
                                    height="180"
                                  />
                                  <div className="image-item__btn-wrapper">
                                    <Button
                                      onClick={() => onImageUpdate(index)}
                                      variant="contained"
                                      sx={{ mr: 2 }}
                                    >
                                      Update
                                    </Button>
                                    <Button
                                      onClick={() => onImageRemove(index)}
                                      variant="contained"
                                    >
                                      Remove
                                    </Button>
                                  </div>
                                </div>
                              ))}
                            </div>
                          </>
                        )}
                      </ImageUploading>
                    )}
                    <InputLabel style={{ marginTop: "2%", }}>
                      Document
                    </InputLabel>
                    <Stack
                      direction="row"
                      spacing={1}
                      style={{ display: " inline" }}
                    >
                      {handOuts.map((i, element) => (
                        <>
                          <Chip
                            key={element}
                            label={i.fileName}
                            variant="outlined"
                            className=""
                            style={{ marginTop: "5px" }}
                            onDelete={() => handleHandoutDelete(i)}
                          />
                        </>
                      ))}
                    </Stack>
                    <input
                      accept="application/pdf"
                      style={{ display: "none" }}
                      id="raised-button-file"
                      type="file"
                      ref={refInput}
                      onChange={(e) => onUploadHandout(e.target?.files[0])}
                    />
                    <Stack
                      direction="row"
                      spacing={1}
                      style={{ display: " block", marginTop: "2%" }}
                    >
                      {handOuts.length > 0 ? null : <Button
                        variant="contained"
                        color="primary"
                        onClick={() => refInput.current.click()}
                      >
                        Upload File
                      </Button>}
                    </Stack>
                  </>
                  {/* } */}
                </Stack>
              </Card>
              <Button
                type="button"
                sx={{ float: "right", mt: 2, ml: 2 }}
                variant="contained"
                onClick={() => navigate(-1)}
              >
                Cancel
              </Button>
              <Button
                type="submit"
                sx={{ float: "right", mt: 2 }}
                variant="contained"
              >
                {params.id ? "Update" : "Create"}
              </Button>
            </Grid>
          </Grid>
        </form>
      </Body>
      <BackdropUI open={fileUploadLoader} />
    </>
  );
}
